import {
  PageTemplate,
  PDFAnalysisSectionDTO,
  PDFBusinessAnalysis,
} from "@pages/platform-analysis/components/buttons/export-pdf/model";
import {
  MARGIN_DEFAULT,
  MAX_PAGE_INDEX_TO_SHOW_MAIN_HEADER,
  PAGE_BODY_HEIGHT,
  PAGE_BODY_HEIGHT_WITHOUT_HEADING,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";
import { PDFBusinessAnalysisSection } from "@pages/platform-analysis/components/buttons/export-pdf/components/sections/business-analysis/index";
import { cloneDeep, isEmpty } from "lodash";
import { pagesHandler } from "@pages/platform-analysis/components/buttons/export-pdf/util";
import { processFeatureAnalysisSectionData } from "@pages/platform-analysis/components/buttons/export-pdf/components/sections/feature-analysis/utils";

const processBusinessAnalysisSectionData = processFeatureAnalysisSectionData;

export const businessAnalysisPageHandler = ({
  pages,
  spaceAvailable,
  businessAnalysis,
}: {
  pages: PageTemplate[];
  spaceAvailable: number;
  businessAnalysis?: PDFBusinessAnalysis;
}) => {
  if (!businessAnalysis || isEmpty(businessAnalysis.sections)) {
    return spaceAvailable;
  }

  const isIncludeMainHeader =
    pages.length <= MAX_PAGE_INDEX_TO_SHOW_MAIN_HEADER;
  const pageBodyHeight = isIncludeMainHeader
    ? PAGE_BODY_HEIGHT
    : PAGE_BODY_HEIGHT_WITHOUT_HEADING;
  const isAppend =
    spaceAvailable > pageBodyHeight / 2 && spaceAvailable !== pageBodyHeight;
  spaceAvailable = isAppend ? spaceAvailable : pageBodyHeight;

  const businessAnalysisComp = (
    currSections: PDFAnalysisSectionDTO[],
    isTableExpand: boolean,
  ) => {
    return (
      <PDFBusinessAnalysisSection
        isTableExpand={isTableExpand}
        businessMetricAnalysis={
          {
            ...businessAnalysis,
            sections: currSections,
          } as PDFBusinessAnalysis
        }
      />
    );
  };

  const sections = cloneDeep(businessAnalysis?.sections);

  let sectionSeparated = processBusinessAnalysisSectionData({
    spaceAvailable,
    sections: sections ?? [],
    isTableExpand: false,
    isBusinessSection: true,
  });

  pagesHandler(
    pages,
    businessAnalysisComp(sectionSeparated?.data, false),
    isAppend,
  );

  while (sectionSeparated.hasContinue && !isEmpty(sections)) {
    spaceAvailable = PAGE_BODY_HEIGHT_WITHOUT_HEADING;
    sectionSeparated = processBusinessAnalysisSectionData({
      spaceAvailable,
      sections: sections ?? [],
      isTableExpand: false,
      isBusinessSection: true,
    });

    pagesHandler(
      pages,
      businessAnalysisComp(sectionSeparated?.data, true),
      false,
    );
  }

  return spaceAvailable - sectionSeparated.occupyHeight - MARGIN_DEFAULT;
};
